export enum BiometricsType {
  TouchId = 'TouchId',
  FaceId = 'FaceId',
}



// WEBPACK FOOTER //
// ./src/model/types/biometrics-type.ts